// plugins/vue3-lottie.client.ts
import Vue3Lottie from "vue3-lottie";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3Lottie);
});
